import * as React from "react";

import "./scss/index.scss";

interface DynamicListBaseProps {
  pageInfo: {
    title: string;
    slug: string;
  };
  paginatedData: any[][];
  pageNumber: number;
}

interface DynamicListBaseState {
  openPageNumbers: number[];
  currentPageNumber: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
}

export class DynamicListBase<T> extends React.Component<
  DynamicListBaseProps & T,
  DynamicListBaseState
> {
  constructor(props) {
    super(props);
    const { pageNumber } = this.props;

    this.state = this.prepareStepState(pageNumber, [pageNumber]);
  }

  prepareStepState = (pageNumber, openPageNumbers) => {
    const { paginatedData } = this.props;
    const [firstOpenPageNumber] = openPageNumbers;
    const [lastOpenPageNumber] = openPageNumbers.slice(-1);

    return {
      currentPageNumber: pageNumber,
      hasNextPage: paginatedData.length !== lastOpenPageNumber,
      hasPrevPage: firstOpenPageNumber !== 1,
      openPageNumbers,
    };
  };

  getPageData = () => {
    const { openPageNumbers } = this.state;
    const { paginatedData } = this.props;

    // @TODO: uncomment when pagination active
    const pageArticles = openPageNumbers.map(page => paginatedData[page - 1]);
    return [].concat.apply([], pageArticles);
  };

  setPage = (pageNumber: number) => {
    const {
      pageInfo: { title, slug },
    } = this.props;

    history.pushState(
      {},
      title,
      `${slug}${pageNumber !== 1 ? `${pageNumber}` : ""}`
    );
    this.setState(({ openPageNumbers }) => {
      const newOpenPageNumbers = openPageNumbers.includes(pageNumber)
        ? openPageNumbers
        : [...openPageNumbers, pageNumber].sort((a, b) => a - b);
      return this.prepareStepState(pageNumber, newOpenPageNumbers);
    });
  };

  prevPage = ev => {
    ev.preventDefault();

    const {
      openPageNumbers: [firstOpenPageNumber],
    } = this.state;
    const newPageNumber = firstOpenPageNumber - 1;
    this.setPage(newPageNumber);
  };

  nextPage = ev => {
    ev.preventDefault();

    const { openPageNumbers } = this.state;
    const [lastOpenPageNumber] = openPageNumbers.slice(-1);
    const newPage = lastOpenPageNumber + 1;
    this.setPage(newPage);
  };
}
export default DynamicListBase;
